<template>
  <div>
    <h4>{{ $t('reporting.routeKPIs') }}</h4>
    <DataTable
      :values="routesData"
      :rows="[
        { name: $t('reporting.kpi.route'), slot: 'route' },
        { name: $t('reporting.kpi.groups'), slot: 'stopsCount', style: 'align-right' },
        { name: $t('reporting.kpi.containers'), slot: 'containersCount', style: 'align-right' },
        {
          name: $t('reporting.kpi.emptiedContainers'),
          slot: 'emptiedContainersCount',
          style: 'align-right',
        },
        { name: $t('reporting.kpi.fillLevelAvg'), slot: 'averageFillLevel', style: 'align-right' },
        { name: $t('reporting.kpi.overflows'), slot: 'overflowsCount', style: 'align-right' },
        { name: $t('reporting.kpi.notifications'), slot: 'notificationsCount', style: 'align-right' },
      ]"
      :layoutFixed="false"
    >
      <template #route="{ value }">
        {{ value.name }}
      </template>
      <template #stopsCount="{ value }">
        {{ value.stops_count }}
      </template>
      <template #containersCount="{ value }">
        {{ value.containers_count }}
      </template>
      <template #emptiedContainersCount="{ value }">
        {{ value.emptied_containers_count }}
        <span
          >({{
            value.containers_count ? ((value.emptied_containers_count / value.containers_count) * 100).toFixed(1) : 0
          }}
          <span>%</span>)</span
        >
      </template>
      <template #averageFillLevel="{ value }">
        {{ (value.average_fill_level * 100).toFixed(1) }} <span>%</span>
      </template>
      <template #overflowsCount="{ value }">
        {{ value.overflows_count }}
      </template>
      <template #notificationsCount="{ value }">
        {{ value.notifications_count }}
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable/index.vue'

export default {
  name: 'ProjectFillLevel',
  components: {
    DataTable,
  },
  props: {
    routesData: { type: Array, required: true },
  },
}
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 0;
  margin-bottom: 0.75rem;
}
</style>
